exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-sort-filter-menu[data-v-fe2d4d90]{min-width:190px}\n", ""]);

// exports
